import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    meals: {
      today: [],
      tomorrow: [],
    },
  },
  getters: {
    getMeals(state) {
      return state.meals
    },
  },
  mutations: {
    SET_MEALS(state, data) {
      state.meals = data
    },
  },
  actions: {
    meals({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post('/portal/meals/getMeals', data)
        .then(response => {
          commit('SET_MEALS', response.data.data)
        })
        .catch(error => console.error(error))
    },
  },
}
